import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactory, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { EncuestaCovidPreguntaDetalleEntity } from '../../../../services/servicio-encuesta-covid.service';
import { AreaTextoComponent } from '../area-texto/area-texto.component';
import { SeleccionUnicaComponent } from '../seleccion-unica/seleccion-unica.component';

@Component({
  selector: 'app-pregunta',
  templateUrl: './pregunta.component.html',
  styleUrls: ['./pregunta.component.css']
})
export class PreguntaComponent implements OnInit {

  @Input() public pregunta: EncuestaCovidPreguntaDetalleEntity;
  @ViewChild('container', {read : ViewContainerRef}) public containter: ViewContainerRef;
  
  constructor(private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    this.build();
  }

  build() {
    const tipoObjeto = Number(this.pregunta.tipoObjeto.codigo);
    switch(tipoObjeto) {

      case 4: {
        this.getSeleccionUnica();
      }break;

      case 5:
      case 6: {
        this.getTexto();
      }break;

    }
  }

  // Construir
  getTexto() {
    const factory: ComponentFactory<AreaTextoComponent> = this.componentFactory.resolveComponentFactory(AreaTextoComponent);
    const component: ComponentRef<AreaTextoComponent> = this.containter.createComponent(factory);
      component.instance.pregunta = this.pregunta;
    return component;
  }

  getSeleccionUnica() {
    const factory: ComponentFactory<SeleccionUnicaComponent> = this.componentFactory.resolveComponentFactory(SeleccionUnicaComponent);
    const component: ComponentRef<SeleccionUnicaComponent> = this.containter.createComponent(factory);
      component.instance.pregunta = this.pregunta;
    return component;
  }

}
